export default __webpack_public_path__ + "static/media/tibet.f0c2e932.svg";